/* eslint-disable no-underscore-dangle */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-lonely-if */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable radix */
/* eslint-disable import/first */
import React, { useState, useEffect } from "react";
import { validate, Network } from "bitcoin-address-validation";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Formik } from "formik";
import { Ring } from "@uiball/loaders";
import styled from "styled-components";
import { Alert } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { fetchAllCurrencies1 } from "@/redux/actions/FetchCoinLists";
import config from "@/config/walletConnect";
import { Button } from "../../../../shared/components/Button";
import Tfaaa from "../../../../containers/Account/MyAccount/Tfaaa";
import { CustomSelect } from "../../../../shared/components/CustomSelect";
import {
    API_URL,
    approveSenExternalWalletOtp,
    getApprover,
    getFee,
    getStrigaWalletAddress,
    getUserInfo,
    sendSubWalletSolToken,
    sendSubWalletTron,
    verifyTFAEmail,
} from "../../../../utils/services/user.service";
import { clearMsg } from "../../../../redux/actions/authActions";
import authHeader from "../../../../utils/services/auth-header";
import { getTotalBalance } from "../../../../redux/actions/sidebarActions";
import SimpleModal from "../../../../shared/components/Modal/SimpleModal";
import { colorAccent } from "../../../../utils/palette";
// import { sendToken } from "../../../../utils/services/auth.services";
import { Tooltip } from "@mui/material";
import { getUserBalanceExternalWalletBSCList, sendToken, sendSubWalletToken } from "../../../../utils/services/user.service";
import { toast } from "react-toastify";
import { useChainContext } from "../../../../containers/context/context";
import numeral from "numeral";
import { SidebarLinkIcon } from "../../../../containers/Layout/components/sidebar/SidebarLink";
// Web3 removed - no longer needed
// Stub for missing tokenAbi.json
const Abi = { abi: [] };

const user = JSON.parse(localStorage.getItem("user"));

const OnchainWalletSendForm = ({ benficiaryToggle, chain, errorMsg, walletOption }) => {
    // No wagmi/web3 needed - using default account values
    const account = { isConnected: false, address: undefined };
    const { REACT_APP_BSC_CONTRACT_ADDRESS, REACT_APP_BSC_DEFAULT_TOKEN } =
        config;
    const {
        REACT_APP_SMART_CHAIN,
        REACT_APP_POLYGON_MATIC,
        REACT_APP_BTC,
        REACT_APP_SOLANA,
        REACT_APP_ETHER,
        REACT_APP_TRON
    } = config;
    const { setRefreshInternalBalance, refreshInternalBalace } = useChainContext()
    const [uSDCoin, setUSDCoin] = useState("");
    const [otp, setOtp] = useState(false);
    const [msg, setMsg] = useState("");
    const [status, setStatus] = useState(200);
    const [approverData, setapproverData] = useState([]);
    const [defaultBenificiary, setDefaultBenificiary] = useState(null);

    const [getApproverID, setApproverID] = useState("");
    const [loading, setloading] = useState(false);
    const [isLoading1, setisLoading1] = useState(false);
    const [load, setloader] = useState(false);
    const [isWallet, setisWallet] = useState(false);
    const [tokenBalance, setTokenBalance] = useState(null);
    const [externalCoin, setExternalCoin] = useState(null);
    const [walletCoin, setwalletCoin] = useState("");
    const [contractAddress, setContractAddress] = useState("");
    const [options, setOptions] = useState([]);
    const [IsBtc, setIsBtc] = useState(false);
    const [btcAddress, setBtcAddress] = useState("");
    const [validBtcAddress, setValidBtcAddress] = useState(null);
    const [resendOtp, setResendOtp] = useState(false);
    const [count, setcount] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [transactionCoin, setTransactionCoin] = useState(null);
    const [walletError, setWalletError] = useState(null);
    const [walletSuccess, setWalletSuccess] = useState(null);
    const [tfaUrl, setTfaUrl] = useState(false);
    const [tfaEmail, setTfaEmail] = useState("");
    const [otpbtn, setOtpbtn] = useState(true);
    const [dataFromChild, setDataFromChild] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [amount1, setAmount] = useState("");
    const [receiver1, setReceiver] = useState("");
    const [recieverSolAddress, setRecieverSolAddress] = useState("");
    const [recieverTronAddress, setRecieverTronAddress] = useState("");
    const [address, setAdddress] = useState("");
    const [coin1, setCoin] = useState("");
    const [selectedChainId, setSelectedChainId] = useState("")
    const [otp1, setOtp1] = useState("");
    const [statusCode, setstatusCode] = useState(400);
    const [externalWalletBSCList, setExternalWalletBSCList] = useState([]);
    const [externalCoinBalance, setExterCoinBalance] = useState(0);
    const [externalCoinAmount, setExterCoinAmount] = useState(0);
    const [exterCoinSymbol, setExterCoinSymbol] = useState(0);
    const [internalAmount, setInternalAmount] = useState(0);
    const [internalCoinApiAmount, setInternalCoinApiAmount] = useState(null);
    const [internalPrice, setInternalPrice] = useState(null);
    const [userInfoData, setUserData] = useState(null);
    const [btnDisable, setBtnDisable] = useState(false);
    const [isTfaVarified, setIsTfaVarified] = useState(false);
    const userSessionData = JSON.parse(localStorage.getItem('user'));
    const [tfaCode, setTfaCode] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [selectedUserBtcAddress, setSelectedUserBtcAddress] = useState("");

    // const [walletOption, setWalletOption] = useState('main_wallet');
    const [withdrawFee, setWithdrawFee] = useState(null);

    const [destinationAddress, setDestinationAddress] = useState(null);
    const [destinationWallet, setDesinatioWallet] = useState(null);
    const [coinList, setCoinList] = useState([])
    const [onChainWalletAddress, setOnchainWalletAddress] = useState(null)
    const [selectedOnchainWalletFrom, setSelectedOnchainWalletFrom] = useState("onChain_wallet")
    const [selectedOnchainWalletTo, setSelectedOnchainWalletTo] = useState("")

    const [strigaWAlletAddress, setStrigaWalletAddress] = useState(null)
    const [recieverTrcAddress, setRecieverTrcAddress] = useState("");
    const { setRefetchActivities, reFetchActivities, onchainGetNetworkRes } = useChainContext()
    const [selectedNetwork, setSelectedNetwork] = useState(REACT_APP_SMART_CHAIN);
    useEffect(() => {
        if (onchainGetNetworkRes?.network_name) {
            setSelectedNetwork(onchainGetNetworkRes.network_name)
            setCoin(onchainGetNetworkRes.symbol)
            setAmount("")
        } else if (!selectedNetwork) {
            setSelectedNetwork(REACT_APP_SMART_CHAIN);
        }
    }, [onchainGetNetworkRes])
    const Networks = [
        {
            label: "Smart Chain",
            value: REACT_APP_SMART_CHAIN,  // Chain ID from environment variable // Chain ID value
        },
    ];

    useEffect(() => {

        if (selectedOnchainWalletTo == 'bank') {
            const allowedSymbols = ["USDC", "EUR", "BTC", "BNB", "ETH", "USDT"];
            const bankCoins = coinList
                ?.filter(item => allowedSymbols.includes(item?.symbol))
                .map(item => ({
                    value: item?.symbol,
                    label: <SmallLabel text={item?.symbol === "META" ? "MET$" : item?.symbol} smallText={item?.quantity} />,
                    price: item?.price,
                    chain_id: item?.chain_id
                }));
            setFilteredOptions(bankCoins);
            return

        } else if (selectedNetwork) {
            // Filter the options based on the selectedNetwork
            const filtered = options.filter(option => option.chain_id === selectedNetwork);
            setFilteredOptions(filtered);
        }
    }, [selectedNetwork, selectedOnchainWalletTo]);
    const getStrigaWallet = async (id) => {
        const payload = {
            "striga_user_id": id
        }
        const res = await getStrigaWalletAddress(payload)
        setStrigaWalletAddress(res?.data?.IBAN)

    }
    useEffect(() => {
        if (selectedOnchainWalletTo === "bank") {
            getStrigaWallet(onChainWalletAddress?.striga_user_id)
        }

    }, [selectedOnchainWalletTo, onChainWalletAddress])


    const handleTfaCode = async () => {
        const requestData = {
            token: tfaCode,
            email: userSessionData.data.user.email,
        };
        try {
            setIsLoading(true);
            const res = await verifyTFAEmail(requestData);

            if (res) {
                setIsLoading(false);
                if (res.data.verified === false) {
                    setTfaCode('');
                    toast.error('Incorrect TFA Code', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else if (res.data.verified === true) {
                    setIsTfaVarified(true)
                    setTfaUrl(false)
                    toast.success('Verify TFA Successfully', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else {
                    setIsLoading(false);
                    setTfaCode('');
                    toast.error('Verify TFA failed', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } else {

                setIsLoading(false);
                console.error('verifyTFA failed:', res);
            }
        } catch (error) {

            setIsLoading(false);
            toast.error(error.response.data.Message, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const dispatch = useDispatch();
    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    });


    useEffect(() => {
        if (coin1 && receiver1 && selectedOnchainWalletTo === 'external') {
            if (["LTX", "WEN", "SOLANA"].includes(coin1) && !recieverSolAddress) {
                toast.error('You are on the wrong chain');
                setBtnDisable(true)
                return
            }
            setBtnDisable(false)
        }
    }, [coin1, receiver1, recieverSolAddress]);

    const handleApproverChange = (event) => {
        const selectedID = event.value;
        setReceiver(selectedID);
    };

    const approverOptions = approverData.map((approver) => ({
        value: approver.address,
        label: approver.label,
    }));

    const walletAddressOption = [
        {
            label: 'Internal Wallet',
            value: "internal_wallet"
        },
        {
            label: 'External Wallet',
            value: "external_wallet"
        }
    ]




    // const { coinList } = useSelector((state) => ({
    //     coinList: state.coinList.data,
    // }));

    const SmallLabel = ({ text, smallText }) => (
        <span>
            {text}{" "}
            <small>
                <b>{smallText}</b>
            </small>
        </span>
    );


    useEffect(() => {
        const updateOptions = async () => {
            // internal coins list from Redux state

            const defaultOptions = coinList?.map((item) => ({
                value: item?.symbol,
                label: <SmallLabel text={item?.symbol === "META" ? "MET$" : item?.symbol} smallText={item?.quantity} />,
                price: item?.price,
                chain_id: item?.chain_id
            }));

            // setOptions(defaultOptions);
            const filtered = defaultOptions.filter(option => option.chain_id === selectedNetwork);
            //         setFilteredOptions(filtered);
            setFilteredOptions(filtered)



            const allowedSymbols = ["USDC", "EUR", "BTC", "BNB", "ETH", "USDT"];

            if (selectedOnchainWalletTo === 'bank') {
                const bankCoins = coinList
                    ?.filter(item => allowedSymbols.includes(item?.symbol))
                    .map(item => ({
                        value: item?.symbol,
                        label: <SmallLabel text={item?.symbol === "META" ? "MET$" : item?.symbol} smallText={item?.quantity} />,
                        price: item?.price,
                        chain_id: item?.chain_id
                    }));
                setFilteredOptions(bankCoins);

                return

            }


            if (walletOption === 'sub_wallet') {
                const onChain = coinList?.map((item) => ({
                    value: item?.symbol,
                    label: <SmallLabel text={item?.symbol === "META" ? "MET$" : item?.symbol} smallText={item?.quantity} />,
                    price: item?.price,
                    chain_id: item?.chain_id
                }));

                setOptions(onChain);
            }
            if (benficiaryToggle === "external") {
                setOptions([]);
            }
            if (benficiaryToggle === "external" && !account.isConnected) {
                setOptions([]);
            }
        };
        if (coinList.length > 0) {
            updateOptions();
        }

    }, [coinList, coinList, selectedOnchainWalletTo, selectedNetwork, walletOption]);


    const fetchMaxBalance = () => {
        // let coinList = [];
        let mapping = {};
        if (benficiaryToggle !== "external") {
            // coinList = coinList;
            coinList.forEach((coin, index) => {
                mapping[coin.symbol] = index;
            });
        } else if (benficiaryToggle === "external") {
            coinList = externalWalletBSCList;
            coinList.forEach((coin, index) => {
                mapping[coin.symbol] = index;
            });
        }
        const index = benficiaryToggle !== "external" ? mapping[coin1] : mapping[exterCoinSymbol];

        if (index !== undefined) {
            setAmount(coinList[index]?.quantity
            );
        }
    };

    async function fetchBalance() {
        // console.log(chain);
        if (window.ethereum) {
            // Web3 functionality removed - no longer needed
            if (account.address !== undefined) {
                // Web3 balance fetching disabled
                setTokenBalance(0);
            } else if (chain === "BTC") {
                // console.log('asdasdadd');
                axios
                    .post(
                        `${API_URL}getBtcWalletBalance`,
                        { walletAddress: btcAddress },
                        {
                            headers: authHeader(),
                        }
                    )
                    .then((response) => {
                        if (response.data.success === true) {
                            const tokenbalance = response.data.balance;

                            if (Number(tokenbalance) === 0) {
                                setStatus(400);
                                setMsg("Not Enough Balance to create contract");
                            } else {
                                setMsg("");
                            }
                            setTokenBalance(Number(tokenbalance));
                        }
                    })
                    .catch((error) => {
                        setStatus(400);
                        if (error.message === "Network Error") {
                            // setMsg(`Please Check Your Internet Connection \n Something went Wrong!!${error?.message}`);
                        } else {
                            // setMsg(`CatchError:${error}${error?.message}`);
                        }
                    });
            } else {
                setMsg("");
            }
        }
    }

    useEffect(() => {
        if (benficiaryToggle === "external") {
            setWalletError(false);
            setOptions([]);
            setContractAddress(REACT_APP_BSC_CONTRACT_ADDRESS);
            setwalletCoin(REACT_APP_BSC_DEFAULT_TOKEN);
            setExternalCoin("BNB");
            setTokenBalance(0);
            fetchBalance();
        }
    }, [chain]);

    React.useEffect(() => {
        if (account.address !== undefined) {
            setisWallet(true);
            // fetchBalance();
        }
        // return setisWallet(false);
    }, [account]);

    const transferWallet = async () => {
        // Web3 functionality removed - no longer needed
        setloader(false);
        setWalletError("Web3 functionality has been disabled. Please use alternative methods.");
        // Web3 transaction code removed
    };

    // Helper function to reset form values
    const resetFormValues = (clearOtp = false, clearTimer = false) => {
        setTfaUrl(false);
        setTfaEmail("");
        setOtpbtn(true);
        setDataFromChild(false);
        setAmount("");
        setReceiver("");
        setAdddress("");
        setCoin("");
        if (clearOtp) {
            setOtp1("");
            setOtp(false);
        }
        if (clearTimer) {
            setMinutes(0);
            setSeconds(0);
            setResendOtp(false);
        }
    };

    // Helper function to update user balance
    const updateUserBalance = () => {
        setRefreshInternalBalance(true);
        dispatch(getTotalBalance());
        dispatch(fetchAllCurrencies1());
        setRefetchActivities(!reFetchActivities);
        fetchSubWallet();
    };

    const saveToken = async () => {

        if (benficiaryToggle === "external") {
            if (isWallet) {
                try {
                    await approveSenExternalWalletOtp(otp1).then(
                        async (response) => {
                            // console.log(response.data);
                            if (response.data.status === 200) {
                                setMinutes(0);
                                setSeconds(0);
                                setResendOtp(false);
                                const { gasOnHold, gasFee, amount } = response.data.response;
                                if (tokenBalance === 0) {
                                    setloading(false);
                                    setStatus(400);
                                    setMsg("Not Enough Balance to create contract");
                                    setOtp(false);
                                    // console.log('not enough');
                                    setTfaUrl(false);
                                    setTfaEmail("");
                                    setOtpbtn(true);
                                    setDataFromChild(false);
                                    setAmount("");
                                    setReceiver("");
                                    setAdddress("");
                                    setCoin("");
                                    setOtp1("");
                                    // setTimeout(() => {
                                    //   setMsg('');
                                    // }, 3000);
                                    return false;
                                }

                                if (tokenBalance - gasOnHold < gasFee) {
                                    setloading(false);
                                    setStatus(400);
                                    setMsg(
                                        "Gas is not enough to create contract for schedule transaction"
                                    );
                                    setOtp(false);
                                    // console.log('gas not enough');
                                    setTfaUrl(false);
                                    setTfaEmail("");
                                    setOtpbtn(true);
                                    setDataFromChild(false);
                                    setAmount("");
                                    setReceiver("");
                                    setAdddress("");
                                    setCoin("");
                                    setOtp1("");
                                    // setTimeout(() => {
                                    //   setMsg('');
                                    // }, 3000);
                                    return false;
                                }

                                if (tokenBalance < parseInt(amount) + parseInt(amount1)) {
                                    setloading(false);
                                    setStatus(400);
                                    setMsg("Insufficient Fund!");
                                    setOtp(false);
                                    // console.log('not Insufficient');
                                    setTfaUrl(false);
                                    setTfaEmail("");
                                    setOtpbtn(true);
                                    setDataFromChild(false);
                                    setAmount("");
                                    setReceiver("");
                                    setAdddress("");
                                    setCoin("");
                                    setOtp1("");
                                    // setTimeout(() => {
                                    //   setMsg('');
                                    // }, 3000);
                                    return false;
                                }
                                // console.log('*****************************');
                                await transferWallet();
                                setloading(false);
                            }
                        },
                        (error) => {
                            const message =
                                (error.response &&
                                    error.response.data &&
                                    error.response.data.message) ||
                                error.message ||
                                error.toString();
                            setStatus(400);
                            setloading(false);
                            if (error.response.data.status === 400) {
                                setMsg(
                                    error.response.data.Message
                                    ||
                                    error.response.data.Error || error.response.data.message
                                );
                                if (error.response.data.Message === "Invalid Otp") {
                                    setResendOtp(true);
                                    setcount(count + 1);
                                } else {
                                    setOtp(false);
                                    setMinutes(0);
                                    setSeconds(0);
                                    //  resetForm({ values: '' });
                                    setTfaUrl(false);
                                    setTfaEmail("");
                                    setOtpbtn(true);
                                    setDataFromChild(false);
                                    setAmount("");
                                    setReceiver("");
                                    setAdddress("");
                                    setCoin("");
                                    setOtp1("");
                                    setTimeout(() => {
                                        setMsg("");
                                        setOtp(false);
                                    }, 3000);
                                }
                            } else {
                                setMsg(message);
                                setloading(false);
                                setTfaUrl(false);
                                setTfaEmail("");
                                setOtpbtn(true);
                                setDataFromChild(false);
                                setAmount("");
                                setReceiver("");
                                setAdddress("");
                                setCoin("");
                                setOtp1("");
                                setTimeout(() => {
                                    setMsg("");
                                    setOtp(false);
                                }, 3000);
                            }
                        }
                    );
                } catch (error) {
                    setStatus(400);
                    setloading(false);
                    // resetForm({ values: '' });
                    setTfaUrl(false);
                    setTfaEmail("");
                    setOtpbtn(true);
                    setDataFromChild(false);
                    setAmount("");
                    setReceiver("");
                    setAdddress("");
                    setCoin("");
                    setOtp1("");
                    setOtp(false);
                    setTimeout(() => {
                        setMsg("");
                    }, 5000);
                    if (error.message === "Network Error") {
                        // setMsg(`Please Check Your Internet Connection \n Something went Wrong!!${error?.message}`);
                    } else {
                        setMsg(`CatchError:${error}${error?.message}`);
                    }
                }
            }
        } else {
            setIsLoading(true);
            try {
                // Prepare receiver address based on chain and wallet type
                let modifiedReceiver;
                if (selectedChainId === 111) {
                    if (selectedOnchainWalletTo === 'external_wallet') {
                        modifiedReceiver = receiver1 || defaultBenificiary;
                    } else if (selectedOnchainWalletTo === 'onChain_wallet' || selectedOnchainWalletTo === 'internal_custodiy') {
                        modifiedReceiver = recieverTrcAddress;
                    }
                } else if (selectedChainId === 123) {
                    if (selectedOnchainWalletTo === 'external_wallet') {
                        modifiedReceiver = receiver1 || defaultBenificiary;
                    } else if (selectedOnchainWalletTo === 'onChain_wallet') {
                        modifiedReceiver = onChainWalletAddress?.onChainAddress;
                    } else {
                        modifiedReceiver = recieverSolAddress;
                    }
                } else {
                    modifiedReceiver = receiver1 || defaultBenificiary;
                }

                // Determine send token function and payload
                let sendTokenFunction;
                let sendTokenPayload;

                if (selectedOnchainWalletFrom === "onChain_wallet") {
                    if (selectedChainId === REACT_APP_SOLANA) {
                        sendTokenFunction = sendSubWalletSolToken;
                        sendTokenPayload = { 
                            coin: coin1, 
                            amount: amount1, 
                            otp: otp1, 
                            wallet_address: destinationWallet || receiver1 || onChainWalletAddress?.onChainSolAddress 
                        };
                    } else if (selectedChainId === REACT_APP_TRON) {
                        sendTokenFunction = sendSubWalletTron;
                        sendTokenPayload = { 
                            coin: coin1, 
                            amount: amount1, 
                            otp: otp1, 
                            wallet_address: recieverTronAddress 
                        };
                    } else {
                        sendTokenFunction = sendSubWalletToken;
                        sendTokenPayload = { 
                            coin: coin1, 
                            amount: amount1, 
                            otp: otp1, 
                            wallet_address: destinationWallet || receiver1 || onChainWalletAddress?.onChainAddress 
                        };
                    }
                }

                // Execute API call
                const res = await sendTokenFunction(sendTokenPayload);

                            if (res.status === 200) {
                                setStatus(200);
                                setMsg(res?.data?.receipt);
                    toast.success(res?.data?.receipt);
                    
                    // Update user balance and coin list
                    updateUserBalance();
                    
                                setloading(false);
                                setIsLoading(false);

                    // Reset form after successful transaction
                                setTimeout(() => {
                                    setMsg("");
                        resetFormValues(true, true);
                        setIsTfaVarified(false);
                                }, 5000);
                            }
            } catch (error) {
                            const message =
                    (error?.response?.data?.message || error?.response?.data?.Message) ||
                                error.message ||
                                error.toString();
                
                            setStatus(400);
                            setloading(false);
                            setIsLoading(false);

                // Handle different error types
                if (error?.response?.data?.status === 400) {
                    const errorMessage = 
                        error.response.data.Message ||
                        error.response.data.Error || 
                        error.response.data.message;
                    
                    setMsg(errorMessage);
                    
                                if (error.response.data.Message === "Invalid Otp") {
                                    setResendOtp(true);
                                    setcount(count + 1);
                                    setTimeout(() => {
                                        setMsg("");
                                    }, 3000);
                                } else {
                        resetFormValues(true, true);
                                    setTimeout(() => {
                                        setMsg("");
                                    }, 3000);
                                }
                            } else {
                    // Handle non-400 errors
                        if (error.message === "Network Error") {
                        setMsg("Network Error: Please check your connection");
                        } else {
                        const errorMsg = error?.response?.data?.Error || message;
                        setMsg(errorMsg || `CatchError: ${error?.message || error}`);
                    }
                    resetFormValues(true, true);
                setTimeout(() => {
                    setMsg("");
                }, 5000);
                }
            }

        }
    };

    const handleDataFromChild = (data) => {
        // console.log('Child to Parent');
        if (data === true) {
            saveToken();
            setDataFromChild(data);
        }
    };

    function checkIfString(value) {
        const characterPattern = /^[A-Za-z]+$/;

        return characterPattern.test(value);
    }

    const CoinConversion = async (amount, coin) => {
        let coinType = coin;
        if (coinType === null) {
            coinType = externalCoin;
        }


        let coinVal = null;
        if (checkIfString(coinType)) {
            coinVal = options.filter((token) => token.label === coinType);
        } else {
            coinVal = options.filter((token) => token.value === coinType);
        }
        coinType = coinVal[0]?.label;
        setTransactionCoin(coinType);
        setwalletCoin(coinVal[0]?.value);
        setloader(false);
        return;

    };
    const OtpSend = async () => {
        setloading(true);
        return axios
            .post(`${API_URL}direct-transaction-otp`, "", { headers: authHeader() })
            .then((response) => {
                if (response.status === 200) {
                    setStatus(200);
                    setloading(false);
                    setMsg(response.data.message);
                    setTimeout(() => {
                        setMsg("");
                    }, 2000);
                }
            })
            .catch((error) => {
                setStatus(400);
                setloading(false);
                if (error.message === "Network Error") {
                    setMsg(
                        `Please Check Your Internet Connection \n Something went Wrong!!${error?.message}`
                    );
                } else {
                    setMsg(`CatchError:${error}${error?.message}`);
                }
                setTimeout(() => {
                    setMsg("");
                }, 3000);
            });
    };
    const SendOtp = () => {
        setOtp(true);
        OtpSend();
    };
    const ResendOtp = () => {
        setloading(true);
        setOtp(true);
        OtpSend();
        setResendOtp(false);
        setcount(count + 1);
        setMinutes(1);
        setSeconds(59);
    };
    const handleBtcChange = (event) => {
        const inputAddress = event.target.value.trim();
        setBtcAddress(event.target.value);
    };

    useEffect(() => {
        if (btcAddress === "") {
            setValidBtcAddress(null); // Reset validation status when the input is empty
        } else {
            setValidBtcAddress(validate(btcAddress, Network.testnet));
        }
    }, [btcAddress]);

    const [searchLoad, setsearchLoad] = useState(false);

    const handleInputChange = (name) => {
        // debugger;
        setsearchLoad(true);

        if (name.length >= 2) {
            getApprover({ name })
                .then((res) => {
                    setsearchLoad(false);

                    const arr = res.data.user.map((i) => ({
                        id: i._id,
                        address: i.address,
                        value: i.name,
                        label: i.name,
                        sol_address: i?.sol_address,
                        onChainAddress: i?.secondary_wallet_address,
                        onChainSolAddress: i?.secondary_wallet_sol_address,
                        striga_user_id: i?.striga_user_id,
                        btc_address: i?.btcAddress,
                        trcWalletAddress: i?.trc_address,
                    }));

                    setsearchLoad(false);
                    // Case-insensitive comparison
                    const matchingOptions = arr.filter(
                        (option) => option.value.toLowerCase() === name.toLowerCase()
                    );

                    setDefaultBenificiary(matchingOptions[0]?.onChainAddress)
                    setRecieverSolAddress(matchingOptions[0]?.sol_address)
                    setOnchainWalletAddress(matchingOptions[0])
                    setOnchainWalletAddress(matchingOptions[0])
                    setRecieverTrcAddress(matchingOptions[0]?.trcWalletAddress)
                    setSelectedUserBtcAddress(matchingOptions[0]?.btc_address || "")


                    setapproverData(matchingOptions);
                })
                .catch((error) => {
                    setsearchLoad(false);
                    setstatusCode(400);

                    if (error.message === "Network Error") {
                        // setMsg(`Please Check Your Internet Connection \n Something went Wrong!!${error?.message}`);
                    } else {
                        setMsg(`CatchError:${error}${error?.message}`);
                        toast.error(`CatchError:${error}${error?.message}`, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }

                    setTimeout(() => {
                        setMsg("");
                    }, 5000);
                });
        } else {
            setapproverData([]); // Clear options when input length is less than 2
        }

        setsearchLoad(false);
    };


    // const handleToggle = () => {
    //   setToggle((prev) => !prev);
    //   // console.log('selectedOnchainWalletTo State: ', selectedOnchainWalletTo);
    // };

    // getting externalWalletBSCList

    const fetchExternalWalletBSCList = async () => {
        const payload = {
            wallet_address: account?.address,
        };
        const res = await getUserBalanceExternalWalletBSCList(payload);
        setExternalWalletBSCList(res?.data?.data);
        return;
    };

    const userData = async () => {
        try {
            const res = await getUserInfo()
            setUserData(res?.data?.User)

        } catch (error) {
            console.log("🚀 ~ userInfo ~ error:", error)
        }
    }

    useEffect(() => {
        if (account?.address) {
            fetchExternalWalletBSCList();
        }
        userData()
    }, []);


    const walletOptions = [
        {
            label: 'Main Wallet', value: "main_wallet"
        },
        {
            label: 'Onchain Wallet', value: "sub_wallet"
        }
    ]



    const fetchgetFee = async () => {
        setIsLoading(true);
        try {
            const requestData = {
                symbol: coin1,
            };
            const response = await getFee(requestData);
            setWithdrawFee(response.data.data)
            setIsLoading(false);

        } catch (error) {
            setIsLoading(false);
            setWithdrawFee(0)

        }
    };

    useEffect(() => {
        if (amount1 && coin1) {

            fetchgetFee()
        }
    }, [coin1, amount1])


    const fetchSubWallet = async () => {
        setIsLoading(false)
        // userBalanceInternalWalletSubWallet removed
    }
    const userDataInfo = JSON.parse(localStorage.getItem("user"));



    useEffect(() => {
        fetchSubWallet()
    }, [])
    useEffect(() => {
        if (userDataInfo) {
            const defaultUser = `${userDataInfo?.data?.user?.firstName} ${userDataInfo?.data?.user?.lastName}`
            handleInputChange(defaultUser)
        }
    }, [selectedOnchainWalletTo])


    const onCopyWalletAddress = (item) => {
        navigator.clipboard.writeText(item);
    };

    const BankWalletOptionsFrom = [
        { label: 'onChain Wallet', value: 'onChain_wallet' },

    ];
    const BankWalletOptionsTo = [
        { label: 'Virtual Wallet', value: 'virtual' },
        { label: 'Bank Wallet ', value: 'bank' },
        { label: 'External Wallet', value: 'external_wallet' },
        // { label: 'Internal CUstodiy ', value: 'internal_custodiy' },
    ];

    const onchainNetworks = [
        {
            label: "Smart Chain",
            value: REACT_APP_SMART_CHAIN,  // Chain ID from environment variable // Chain ID value
        },
    ];



    useEffect(() => {

        if (selectedOnchainWalletTo === "virtual") {
            // Only Smart Chain is available, so always use address
            setReceiver(onChainWalletAddress?.address)
        }
        // if (selectedOnchainWalletTo === "internal_custodiy") {
        //     console.log('inside if 1')
        //     if (selectedNetwork == REACT_APP_SMART_CHAIN || selectedNetwork == REACT_APP_POLYGON_MATIC || selectedNetwork == REACT_APP_ETHER) {
        //         console.log('inside true')
        //         setReceiver(onChainWalletAddress?.address)
        //     }
        //     else if (selectedNetwork == REACT_APP_SOLANA) {
        //         setReceiver(onChainWalletAddress?.sol_address)
        //     }
        //     else if (selectedNetwork == REACT_APP_TRON) {
        //         setReceiver(onChainWalletAddress?.trcWalletAddress)
        //     }
        //     else if (selectedNetwork == REACT_APP_BTC) {
        //         setReceiver(onChainWalletAddress?.btc_address)
        //     }
        // }

    }, [selectedNetwork, receiver1])
    return (
        <>
            <div
                className="loader-overlay"
                style={{
                    display: isLoading ? "flex" : "none", // Use flex display when loading
                    justifyContent: "center", // Center horizontally
                    alignItems: "center", // Center vertically
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    // background: "rgba(255, 255, 255, 0.8)",
                    zIndex: 999,
                }}
            >
                <Ring size={65} color="#00897B" />
            </div>
            <div
                className="col-12 w-100"
            // style={{
            //   display: "flex",
            //   justifyContent: "center", // Center horizontally
            // }}
            >

                {walletError && (
                    <WalletError className="input feedback">{walletError}</WalletError>
                )}
                {walletSuccess && (
                    <WalletSuccess className="input feedback">
                        {walletSuccess}
                    </WalletSuccess>
                )}
                <Formik
                    initialValues={{
                        receiver: "",
                        amount: "",
                        coin: benficiaryToggle === "external" ? externalCoin : "",
                        otp: "",
                        isRecipientAddress: true,
                    }}
                    onSubmit={(values, { resetForm }) => {


                        if (otp1 === "") {

                            if (benficiaryToggle === "external") {
                                if (isWallet) {
                                    SendOtp();
                                } else {
                                    setloading(true);
                                    setStatus(400);
                                    setMsg("Your Wallet is not connected");
                                    setOtp(false);
                                    setloading(false);
                                    setTimeout(() => {
                                        setMsg("");
                                    }, 4000);
                                }
                            } else {
                                SendOtp();
                            }
                        } else {
                                setloading(true);
                                saveToken();
                        }
                    }}
                    validate={(values) => {
                        const errors = {};
                        const regex = /^[0-9\b.]+$/;
                        const negRegex = /^(?:[1-9]\d*|0)?(?:\.\d+)?$/;
                        if (!receiver1 && walletOption == "main_wallet") {
                            errors.receiver = "Recipeint Wallet Address is Required";
                        }
                        if (!amount1) {
                            errors.amount = "Amount is Required!!";
                        } else if (
                            ["ETH", "BNB", "MATIC"].includes(
                                coin1 === null ? externalCoin : coin1
                            )
                        ) {
                            if (!negRegex.test(amount1)) {
                                errors.amount = "Amount must be in digit e.g 10,2.3";
                            }
                        } else if (
                            !["ETH", "BNB", "MATIC"].includes(
                                coin1 === null ? externalCoin : coin1
                            )
                        ) {
                            if (!regex.test(amount1)) {
                                errors.amount = `Amount ${coin1 === "" ? "" : `in ${coin1}`
                                    } must be in digit and should be greater then 0 e.g 10`;
                            }
                        }
                        // console.log(values);
                        const coinVal = coin1 === null ? externalCoin : coin1;
                        if (!coinVal) {
                            errors.coin = "coin is Required!!";
                        }
                        if (otp) {
                            const otpRegex = /^[0-9\b]+$/;
                            if (!otp1) {
                                errors.otp = "Otp is Required!!";
                            } else if (!otpRegex.test(otp1)) {
                                errors.otp = "Invalid Otp!! must be in digits";
                            }
                        }
                        return errors;
                    }}
                >
                    {(props) => {
                        const {
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                        } = props;
                        return (
                            <form onSubmit={handleSubmit}>
                                <Alert
                                    variant={status === 200 ? "success" : "danger"}
                                    show={msg !== ""}
                                    style={{
                                        marginTop: "1rem",
                                        width: "100%",
                                        textAlign: "center",
                                        backgroundColor: status === 200 ? "#c1f9c1" : "#f1beb0",
                                        color: status === 200 ? "#22bb33" : "red",
                                    }}
                                    onClose={() => {
                                        setMsg("");
                                    }}
                                    dismissible
                                >
                                    {msg}
                                </Alert>
                                <Alert
                                    variant={
                                        statusCode === 200 || statusCode === "success"
                                            ? "success"
                                            : "danger"
                                    }
                                    show={errorMsg !== undefined}
                                    style={{
                                        marginTop: "1rem",
                                        width: "100%",
                                        textAlign: "center",
                                        backgroundColor:
                                            statusCode === 200 || statusCode === "success"
                                                ? "#c1f9c1"
                                                : "#f1beb0",
                                        color:
                                            statusCode === 200 || statusCode === "success"
                                                ? "#22bb33"
                                                : "red",
                                    }}
                                    onClose={() => {
                                        dispatch(clearMsg());
                                    }}
                                    dismissible
                                >
                                    {errorMsg}
                                </Alert>
                                {selectedNetwork && <div className="d-flex p-2 rounded-3" style={{
                                    background: '#eb771a'
                                }} >
                                    <strong className='text-white'>Attention!</strong> <span className='text-white px-2'>Make sure you select the same network for deposit, or assets may be lost</span>
                                </div>}


                                <div className="row mb-1">
                                    <div className="col-lg-4 col-md-4 col-sm-12 mt-1">
                                        <SelectDiv style={{ display: "flex", width: "100%" }}>
                                            <label
                                                htmlFor="email"
                                                className="text-white"
                                                style={{ fontSize: "small" }}
                                            >
                                                From
                                            </label>
                                            <CustomSelect
                                                value={selectedOnchainWalletFrom}
                                                onChange={(value) => {

                                                    setSelectedOnchainWalletFrom(value.value)

                                                }}
                                                options={
                                                    BankWalletOptionsFrom
                                                }
                                                isSearchable={false}
                                            />
                                        </SelectDiv>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12 mt-1">
                                        <SelectDiv style={{ display: "flex", width: "100%" }}>
                                            <label
                                                htmlFor="email"
                                                className="text-white"
                                                style={{ fontSize: "small" }}
                                            >
                                                To
                                            </label>
                                            <CustomSelect
                                                value={selectedOnchainWalletTo}
                                                onChange={(value) => {

                                                    setSelectedOnchainWalletTo(value.value)
                                                }}
                                                options={
                                                    BankWalletOptionsTo
                                                }

                                                isSearchable={false}
                                            />
                                        </SelectDiv>
                                    </div>




                                    {selectedOnchainWalletTo === 'external_wallet' ? (
                                        <div className="col-md-4 col-lg-4 col-sm-12">
                                            <InputDiv>
                                                <Label htmlFor="email" className="mt-3">
                                                    Recipient Address *
                                                </Label>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <ChatSearchInput
                                                        name="receiver"
                                                        type="text"
                                                        // disabled
                                                        placeholder="Enter recipient address"
                                                        value={receiver1}
                                                        onChange={(value) => {
                                                            setReceiver(value.target.value);
                                                        }}
                                                        onBlur={handleBlur}
                                                        className={
                                                            errors.receiver && touched.receiver && "error"
                                                        }
                                                    />
                                                    {errors.receiver && touched.receiver && (
                                                        <Error className="input feedback">
                                                            {errors.receiver}
                                                        </Error>
                                                    )}
                                                </div>
                                            </InputDiv>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="d-flex align-items-center gap-2 col-md-4 col-lg-4 col-sm-12">
                                                <InputDiv>
                                                    <Label htmlFor="email" className="mt-1">
                                                        Recipient Address *
                                                        <Tooltip
                                                            text="Copy Address"
                                                            placement="top"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <SidebarLinkIcon
                                                                style={{ cursor: "pointer" }}
                                                                className="ml-1 lnr lnr-book"

                                                                onClick={() => {
                                                                    onCopyWalletAddress(
                                                                        selectedOnchainWalletTo === "bank"
                                                                            ? strigaWAlletAddress : selectedChainId === REACT_APP_TRON
                                                                                ? recieverTronAddress : receiver1
                                                                    )
                                                                    toast.success('Copied!')
                                                                }
                                                                }
                                                            />
                                                        </Tooltip>
                                                    </Label>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <CustomSelect
                                                            isLoading={searchLoad}
                                                            name="receiver"
                                                            onInputChange={handleInputChange}
                                                            placeholder={
                                                                selectedOnchainWalletTo === "bank"
                                                                    ? strigaWAlletAddress : selectedChainId === REACT_APP_TRON
                                                                        ? recieverTronAddress : receiver1
                                                            }

                                                            onChange={(value) => {
                                                                setReceiver(value.address);
                                                                setOnchainWalletAddress(value)
                                                                if (selectedOnchainWalletTo === "onChain_wallet" && !value?.onChainAddress) {
                                                                    toast.error("This user don't have Onchain Wallet")
                                                                }
                                                                setRecieverSolAddress(value.sol_address)
                                                                setRecieverTronAddress(value.trcWalletAddress);
                                                            }}
                                                            // value={receiver1}
                                                            options={approverData}
                                                            isSearchable
                                                        />
                                                        {" "}
                                                        {errors.receiver && touched.receiver && (
                                                            <Error className="input feedback">
                                                                {errors.receiver}
                                                            </Error>
                                                        )}
                                                    </div>

                                                </InputDiv>

                                            </div>

                                        </>
                                    )}

                                    {selectedOnchainWalletTo !== 'bank' && (
                                        <div className="col-lg-4 col-md-4 col-sm-12 mt-1">
                                            <SelectDiv style={{ display: "flex", width: "100%" }}>
                                                <label
                                                    htmlFor="email"
                                                    className="text-white"
                                                    style={{ fontSize: "small" }}
                                                >
                                                    Select Network
                                                </label>
                                                <CustomSelect
                                                    value={selectedNetwork}
                                                    onChange={(value) => {
                                                        setSelectedNetwork(value.value)
                                                    }}
                                                    options={Networks}
                                                    isSearchable={false}
                                                />
                                            </SelectDiv>
                                        </div>
                                    )}

                                    {(selectedNetwork || selectedOnchainWalletTo === 'bank') && (
                                        <div className="col-lg-4 col-md-12 col-sm-12 mt-1">
                                        <SelectDiv style={{ display: "flex", width: "100%" }}>
                                            <label
                                                htmlFor="email"
                                                className="text-white"
                                                style={{ fontSize: "small" }}
                                            >
                                                Coins *
                                            </label>
                                            {isLoading1 ? (
                                                <div>
                                                    <Spinner style={{ color: colorAccent }} />
                                                </div>
                                            ) : (
                                                <CustomSelect
                                                    value={coin1}
                                                    onChange={(value) => {
                                                        setSelectedChainId(value?.chain_id)

                                                        setCoin(value.value);
                                                        setInternalPrice(value?.price);
                                                        setExterCoinBalance(value?.label?.props?.text);
                                                        setExterCoinAmount(value?.price?.priceDta?.price);
                                                        setExterCoinSymbol(value?.price?.priceDta?.symbol);
                                                        setInternalAmount(value?.label?.props?.smallText);
                                                        setAmount("");
                                                    }}
                                                    options={filteredOptions}
                                                />
                                            )}
                                            {/* {benficiaryToggle === "external" ? (
                          tokenBalance === "" ? (
                            ""
                          ) : (
                            <div className="mt-2">
                              <span style={{ color: "#fff" }}>
                                <label
                                  htmlFor="email"
                                  className="text-white"
                                  style={{ fontSize: "medium" }}
                                >
                                  Balance :
                                </label>
                              </span>{" "}
                              <span style={{ color: "#4ce1b6" }}>
                                {tokenBalance}
                              </span>
                            </div>
                          )
                        ) : (
                          ""
                        )} */}
                                            {errors.coin && touched.coin && (
                                                <Error className="input feedback">
                                                    {errors.coin}
                                                </Error>
                                            )}
                                        </SelectDiv>
                                    </div>
                                    )}
                                    {
                                        destinationAddress?.label == "External Wallet" && (
                                            <div className="col-lg-3 col-md-12 col-sm-12 mt-1">
                                                <InputDiv>
                                                    <label htmlFor="email" className="text-white mb-3">
                                                        Destination Address *
                                                    </label>
                                                    <ChatSearchInput
                                                        name="amount"
                                                        type="text"
                                                        placeholder="Enter Destination Address"
                                                        value={destinationWallet}
                                                        onChange={(value) => {
                                                            setDesinatioWallet(value.target.value);

                                                        }}
                                                        onBlur={handleBlur}
                                                        className={`form-control w-100 `}
                                                    />

                                                </InputDiv>
                                            </div>
                                        )
                                    }
                                    <div className="col-lg-3 col-md-12 col-sm-12 mt-1">
                                        <InputDiv>
                                            <label htmlFor="email" className="text-white mb-3">
                                                Amount *
                                            </label>
                                            <ChatSearchInput
                                                name="amount"
                                                type="number"
                                                placeholder="Enter your amount"
                                                value={amount1}
                                                onChange={(value) => {
                                                    // console.log('asas', value);
                                                    setAmount(value.target.value);
                                                    if (coin1 !== "") {
                                                        return CoinConversion(value.target.value, coin1);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                className={`form-control w-100 ${errors.amount && touched.amount && "error"
                                                    }`}
                                            />
                                            {errors.amount && touched.amount && (
                                                <Error className="input feedback">
                                                    {errors.amount}
                                                </Error>
                                            )}
                                        </InputDiv>
                                    </div>
                                    {isLoading1 ? (
                                        ""
                                    ) : (
                                        <div className="col-lg-1 col-md-12 col-sm-12 mt-1">
                                            <InputDiv>
                                                <MaxButton
                                                    onClick={fetchMaxBalance}
                                                    disabled={loading}
                                                    style={{ marginTop: "1rem" }}
                                                >
                                                    {loading ? "Loading...." : "Max"}
                                                </MaxButton>
                                            </InputDiv>
                                        </div>
                                    )}
                                </div>

                                <div v className="row mb-1">
                                    <div className="col-lg-4 col-md-12 col-sm-12 mt-1">
                                        {load && benficiaryToggle !== "external" ? (
                                            <span
                                                style={{
                                                    color: "#4ce1b6",
                                                    fontSize: "14px",
                                                    marginTop: "20px",
                                                }}
                                            >
                                                Loading.....
                                            </span>
                                        ) : coin1 || externalCoin ? (
                                            <span>
                                                <InputDiv>
                                                    <label htmlFor="email" className="text-white mt-2">
                                                        Balance
                                                    </label>
                                                    <ChatSearchInput
                                                        type="text"
                                                        disabled
                                                        value={
                                                            benficiaryToggle === "external"
                                                                ? `${numeral(externalCoinAmount * amount1).format('0,0.00')} $`
                                                                : `${numeral(internalPrice * amount1).format('0,0.00')} $`
                                                        }
                                                        className="form-control w-100 bg-transparent mb-3"
                                                    />
                                                </InputDiv>
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    {withdrawFee?.fee >= 0 && (
                                        <div className="col-lg-4 col-md-12 col-sm-12 mt-1">
                                            <InputDiv>
                                                <label
                                                    htmlFor="email"
                                                    className="text-white mt-2"
                                                    style={{ fontSize: "small" }}
                                                >
                                                    withdrawFee
                                                </label>
                                                <div>
                                                    <ChatSearchInput
                                                        name="otp"
                                                        placeholder="withdrawFee"
                                                        value={`${withdrawFee?.percentage > 0
                                                            ? (amount1 / 100 * withdrawFee.percentage).toFixed(5)
                                                            : Number(withdrawFee?.fee || 0).toFixed(5)
                                                            } ${withdrawFee?.symbol || coin1}`}
                                                        className={`form-control w-100 `}

                                                    />

                                                </div>
                                            </InputDiv>
                                        </div>
                                    )}
                                    {otp && (
                                        <div className="col-lg-4 col-md-12 col-sm-12 mt-1">
                                            <InputDiv>
                                                <label
                                                    htmlFor="email"
                                                    className="text-white mt-2"
                                                    style={{ fontSize: "small" }}
                                                >
                                                    OTP *
                                                </label>
                                                <div>
                                                    <ChatSearchInput
                                                        name="otp"
                                                        type="text"
                                                        placeholder="Enter your otp"
                                                        value={otp1}
                                                        onChange={(e) => setOtp1(e.target.value)}
                                                        onBlur={handleBlur}
                                                        className={`form-control w-100 ${errors.otp && touched.otp && "error"
                                                            }`}
                                                    />
                                                    {errors.otp && touched.otp && (
                                                        <Error className="input feedback">
                                                            {errors.otp}
                                                        </Error>
                                                    )}
                                                </div>
                                            </InputDiv>
                                        </div>
                                    )}

                                    {otp && userSessionData?.data?.user?.google_auth_status && (
                                        <div className="col-lg-3 col-md-12 col-sm-12 mt-1">
                                            <InputDiv>
                                                <label htmlFor="email" className="text-white mb-3">
                                                    Verify TFA *
                                                </label>
                                                <ChatSearchInput
                                                    name="tfa"
                                                    type="text"
                                                    placeholder="Enter Code"
                                                    value={tfaCode}
                                                    onChange={(e) => {
                                                        setTfaCode(e.target.value);
                                                    }}
                                                />
                                            </InputDiv>

                                            <InputDiv>
                                                <FormButton
                                                    variant="outline-white"
                                                    className="py-2 mt-4 w-100 btn-sm"
                                                    onClick={handleTfaCode}
                                                    disabled={isTfaVarified}
                                                >
                                                    {isTfaVarified ? "Verified" : "Verify"}
                                                </FormButton>
                                            </InputDiv>
                                        </div>
                                    )}
                                </div>

                                <p style={{ fontSize: "small" }} className="text-white">
                                    Approx Amount after Fee:
                                    <strong>
                                        {withdrawFee?.percentage > 0
                                            ? (amount1 - (amount1 / 100 * withdrawFee.percentage)).toFixed(5)
                                            : (amount1 - Number(withdrawFee?.fee || 0)).toFixed(5)}{" "}
                                    </strong>
                                </p>
                                <div className="row mb-1">
                                    <div className="col-lg-4 col-md-12 col-sm-12 mt-1 mx-auto">
                                        {loading}
                                        {otpbtn && (
                                            <FormButton
                                                type="submit"
                                                variant="outline-success"
                                                className="py-2 mt-5 w-100"
                                                disabled={otp && otp1 === "" || btnDisable || (otp1 && userSessionData?.data?.user?.google_auth_status && !isTfaVarified) || (externalCoinAmount * amount1 <= 0 || internalPrice * amount1 <= 0)}
                                            >
                                                {loading ? "Loading...." : "Send"}
                                            </FormButton>
                                        )}
                                        {otpbtn &&
                                            ((seconds > 0 || minutes > 0) && count < 3 ? (
                                                <span style={{ color: colorAccent }}>
                                                    Time Remaining:{" "}
                                                    {minutes < 10 ? `0${minutes}` : minutes}:
                                                    {seconds < 10 ? `0${seconds}` : seconds}
                                                </span>
                                            ) : null)}
                                        {otpbtn && resendOtp && count < 4 && (
                                            <FormButton
                                                // type="submit"
                                                variant="primary-outline"
                                                className="py-2 mt-2 w-100"
                                                disabled={seconds > 0 || minutes > 0}
                                                onClick={() => {
                                                    ResendOtp();
                                                }}
                                            >
                                                Resend Otp
                                            </FormButton>
                                        )}
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-4 col-lg-4 col-sm-12 mx-auto">
                                        <Tfaaa
                                            tfaEmail={tfaEmail}
                                            tfaUrl={tfaUrl}
                                            onDataFromChild={handleDataFromChild}
                                        />
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
                <SimpleModal isActive={IsBtc} onClose={() => setIsBtc(false)}>
                    <InputDiv>
                        <Grid>
                            <Label htmlFor="email">Add BTC wallet Address</Label>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                }}
                            >
                                <input
                                    name="name"
                                    type="text"
                                    placeholder="Enter your address"
                                    value={btcAddress}
                                    onChange={handleBtcChange}
                                />
                                {validBtcAddress === false && (
                                    <Error className="input feedback">
                                        {validBtcAddress === false
                                            ? "Invalid BTC Address"
                                            : "Valid BTC Address"}
                                    </Error>
                                )}
                            </div>
                        </Grid>
                    </InputDiv>
                    <InputDiv>
                        <Grid>
                            <Label />
                            {validBtcAddress ? (
                                <Button
                                    className="w-25"
                                    onClick={() => {
                                        fetchBalance();
                                    }}
                                >
                                    Submit
                                </Button>
                            ) : (
                                <Button className="w-25" disabled>
                                    Submit
                                </Button>
                            )}
                        </Grid>
                    </InputDiv>
                </SimpleModal>

            </div>
        </>
    );
};

export default OnchainWalletSendForm;
const Label = styled.label`
        @media screen and (max-width: 876px) {
          margin - bottom: 0px;
        margin-top: 8px;
}
        `;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 15rem 20rem 20rem;
  grid-gap: 1rem;
  width: 100%;
  @media screen and (max-width: 876px) {
    grid-template: none;
  }
`;
const InputDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 5px 0px;
  font-size: 14px;
`;
const Error = styled.div`
  color: #e66e6e;
  padding: 2px 0px;
  font-size: 12px;
  cursor: none;
`;
const WalletError = styled.div`
  color: #e66e6e;
  padding: 2px 0px;
  font-size: 16px;
  cursor: none;
`;
const WalletSuccess = styled.div`
  color: #4ce1b6;
  padding: 2px 0px;
  font-size: 16px;
  cursor: none;
`;
const SelectDiv = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 5px 0px;
  font-size: 14px;
`;

const MaxButton = styled.button`
  background: linear-gradient(90deg, #80ffc0, #80e0ff);
  color: #001018;
  padding: 10px 10px;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
//   min-width: 120px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(128, 255, 192, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const FormButton = styled(Button)`
  color: "white";
  mergin-top: 1rem;
`;

const ChatSearchInput = styled.input`
  width: 100%;
  height: 100%;
  font-size: 12px;
  transition: all 0.3s;
  background: transparent;
  border: none;
  padding-left: 2px;
  border-bottom: 1px solid #b1b1b1;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  color: #b1b1b1;

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
    color: #b1b1b1;
    background: transparent;
    border-bottom: 2px solid #47c9a4;
  }

  &::-webkit-input-placeholder {
    color: #b1b1b1;
  }
  &::-moz-placeholder {
    color: #b1b1b1;
  }
  &:-moz-placeholder {
    color: #b1b1b1;
  }
  &:-ms-input-placeholder {
    color: #b1b1b1;
  }
`;
